
import { gql } from "graphql-tag";

import { getVariant } from "~/utils";

const MATTRESS_PROTECTOR_QUERY = gql`
  query product($id: ID!) {
    product(id: $id) {
      id
      title
      handle
      variants(first: 10) {
        nodes {
          id
          price {
            amount
          }
          compareAtPrice {
            amount
          }
          image {
            id
            altText
            w_400_h_400: url(
              transform: {
                maxWidth: 400
                maxHeight: 400
                preferredContentType: PNG
              }
            )
            w_400_h_400_webp: url(
              transform: {
                maxWidth: 400
                maxHeight: 400
                preferredContentType: WEBP
              }
            )
          }
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`;

export default {
  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
  },

  data: () => ({ mattressProtector: null }),

  async fetch() {
    if (!this.product.mattress_protector) {
      return;
    }

    const { data } = await this.$getShopifyData({
      query: MATTRESS_PROTECTOR_QUERY,
      variables: { id: this.product.mattress_protector },
    });

    this.mattressProtector = data.product;
  },

  computed: {
    selectedSize() {
      return this.selectedMattressProtector?.selectedOptions.Size.value;
    },
    mattressProtectorVariants() {
      return this.mattressProtector
        ? this.mattressProtector.variants.nodes.map(getVariant)
        : [];
    },
    selectedMattressProtector() {
      const sizeValue = this.selectedVariant.selectedOptions?.Size?.value;
      if (!sizeValue) {
        return;
      }

      return this.mattressProtectorVariants.find(
        variant =>
          variant.selectedOptions.Size?.value.toUpperCase() ===
          sizeValue.toUpperCase()
      );
    },
    mattressProtectorTitle() {
      return `Add ${this.mattressProtector.title} - ${this.selectedSize}`;
    },
    imageOptions() {
      const image = this.selectedMattressProtector?.image ?? {};

      return {
        src: image.w_400_h_400,
        webpSrc: image.w_400_h_400_webp,
        alt: "Mattress protector image",
        widths: ["160"],
        width: "160",
        height: "160",
      };
    },
    mattressProtectorUrl() {
      return `${this.mattressProtector.handle}?variant=${this.selectedMattressProtector?.id}`;
    },
    isMattressProtectorAdded() {
      return (
        this.$store.state.pdp.mattressProtector?.parentHandle ==
        this.product.handle
      );
    },
  },

  methods: {
    handleChange() {
      const { variantId, compareAtPrice } = this.selectedMattressProtector;
      const payload = !this.isMattressProtectorAdded
        ? { variantId, compareAtPrice, parentHandle: this.product.handle }
        : null;
      this.$store.dispatch("pdp/setMattressProtector", payload);
    },
  },
};
